import React from 'react';
/**
 * QuestionRendererFactory — Routes question type → renderer component.
 *
 * DDD co-locatie: moved from components/practice/renderers/ in s66.
 */
import { QuestionRendererProps } from './types';
import { getQuestionTypeConfig } from '../../../content';
import { QuestionErrorBoundary } from '../QuestionErrorBoundary';
import { warn, error as logError } from '../../../utils/logger';
interface FactoryProps extends QuestionRendererProps {
  onSkipQuestion?: () => void;
}
/**
 * Routes question type → renderer component, wrapped in a per-renderer
 * error boundary so a single renderer crash shows a skip-friendly message
 * instead of taking down the entire session.
 */
export function QuestionRendererFactory(props: FactoryProps) {
  const {
    question,
    moduleColor
  } = props;
  const questionType = question.questionType || 'multiple_choice';
  const config = getQuestionTypeConfig(questionType);
  const Renderer = config.Renderer;
  if (!Renderer) {
    logError(`[RendererFactory] No renderer found for questionType "${questionType}" (question ${question.id})`);
    return <div className="p-4 bg-red-50 rounded-xl text-red-700 font-bold" data-id="element-8205">
        ⚠️ Renderer niet gevonden voor type "{questionType}"
      </div>;
  }
  const rendererName = Renderer.displayName || Renderer.name || questionType;
  return <QuestionErrorBoundary questionId={question.id} onReset={() => {
    logError(`[RendererCrash] Renderer "${rendererName}" (type: ${questionType}) crashed for question ${question.id} (family: ${question.familyId ?? 'unknown'}, tier: ${question.tier ?? '?'})`);
    warn(`Question ${question.id} renderer "${rendererName}" crashed and was reset`);
  }} onSkipQuestion={props.onSkipQuestion} data-id="element-8206">
      <Renderer {...props} moduleColor={moduleColor} data-id="element-8207" />
    </QuestionErrorBoundary>;
}